import { Controller } from "@hotwired/stimulus"

export default class DragSortController extends Controller {
  static targets = ["item"]
  declare itemTargets: HTMLElement[]

  private dragging: HTMLElement | null = null

  connect() {
    this.itemTargets.forEach(item => this.setupItem(item))
  }

  private setupItem(item: HTMLElement) {
    item.setAttribute("draggable", "true")
    item.addEventListener("dragstart", (e) => this.onDragStart(e, item))
    item.addEventListener("dragend",   () => this.onDragEnd(item))
    item.addEventListener("dragover",  (e) => this.onDragOver(e, item))
    item.addEventListener("drop",      (e) => e.preventDefault())
  }

  private onDragStart(e: DragEvent, item: HTMLElement) {
    this.dragging = item
    setTimeout(() => item.classList.add("opacity-40"), 0)
    e.dataTransfer!.effectAllowed = "move"
  }

  private onDragEnd(item: HTMLElement) {
    item.classList.remove("opacity-40")
    this.dragging = null
    this.syncPositions()
  }

  private onDragOver(e: DragEvent, target: HTMLElement) {
    e.preventDefault()
    if (!this.dragging || target === this.dragging) return
    const rect = target.getBoundingClientRect()
    if (e.clientY > rect.top + rect.height / 2) {
      target.after(this.dragging)
    } else {
      target.before(this.dragging)
    }
  }

  private syncPositions() {
    this.element.querySelectorAll<HTMLElement>("[data-drag-sort-target='item']")
      .forEach((item, i) => {
        const input = item.querySelector<HTMLInputElement>("[data-position-input]")
        if (input) input.value = String(i + 1)
      })
  }
}
